import { useEffect } from 'react'
import { useActions } from 'store/hooks'

import { useAppSelector } from 'store/hooks'

export const useCertificates = () => {
  const { isLoading, certificates } = useAppSelector((state) => state.certificates)

  const { getCertificates } = useActions()

  useEffect(() => {
    getCertificates()
  }, [getCertificates])

  return { isLoading, certificates }
}
